// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1iV6d","header":"styles_header__3RlRS","status":"styles_status__k6K_S","title":"styles_title__21vgE","actions":"styles_actions__1s9PM"};